

import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube , FaWhatsapp, FaEnvelope} from "react-icons/fa";
import { Link } from 'react-router-dom';

import './Footer.scss'
// import logo from "../../assets/logo2.png";
import logo from "../../assets/logo (1).jpg";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" ><img src={logo} alt="logo" /></Link>
          <p>Bengaluru law college</p>
        </div>

        <div className="footer-links">
          <h4>Address</h4>
          <ul>
            <li>#19/74 8th Cross, Shakthi Ganapathi Nagar, Kamala Nagar main road, Basaveshwaranagar, Near Ashoka Hospital, Bengaluru -560079</li>

            {/* <li>#19/74 8th Cross, Shakthi Ganapathi Nagar</li>
            <li>Kamala nagar main road, </li>
            <li>Basaveshwaranagar,</li>
            <li>Near Ashoka Hospital, </li>
            <li>Bengaluru -560079</li> */}
            {/* <li><a href="/privacy">Privacy Policy</a></li> */}
          </ul>
        </div>

<div className="footer-links">
  <h4>Quick Links</h4>
  <ul>
    <li><Link to="/" >Home</Link></li>
    <li><Link to="/Event2526" >Gallery</Link></li>
    <li><Link to="/admissions" >Admission</Link></li>
    {/* <li><Link to="/crops" > Crops</Link></li> */}
    <li><Link to="/contact" >Contact Us</Link></li>
  </ul>
</div>

        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1ZKMX97uyg/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/bengaluru_law_college?igsh=MXJiaXF1a2IyZ2Jqcw%3D%3D" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            {/* <a href="https://www.youtube.com/"><FaYoutube /></a> */}
            <a href="https://wa.me/919632050573" target="_blank" rel="noopener noreferrer"> <FaWhatsapp /> </a>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=bangalorelawcollege6@gmail.com" target="_blank" rel="noopener noreferrer"><FaEnvelope /></a>


            
          </div>
        </div>
      </div>
      

      <div className="footer-bottom">
        © {new Date().getFullYear()}Bengalurulawcollege All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
